"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _objectWithoutProperties = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFlag = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _stylitas = require("@creditas/stylitas");

var _icon = require("./components/icon.style");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.string,
  color: _propTypes.string
} : {};
var defaultProps = {
  color: '#566'
};

var Icon = function Icon(_ref) {
  var className = _ref.className,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["className", "color"]);

  return (0, _core.jsx)("div", {
    className: className
  }, (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), (0, _core.jsx)("defs", null, (0, _core.jsx)("path", {
    d: "M5 0c1.417 0 2.383.276 4.371 1.072C11.133 1.776 11.917 2 13 2c1.189 0 2.094-.165 2.754-.428.341-.137.508-.249.539-.28C16.923.663 18 1.11 18 2v12a1 1 0 01-.293.707c-.22.22-.614.483-1.21.721-.903.362-2.06.572-3.497.572-1.417 0-2.383-.276-4.371-1.072C6.867 14.224 6.083 14 5 14c-1.189 0-2.094.165-2.754.428a4.09 4.09 0 00-.247.108L2 21a1 1 0 01-2 0V2a1 1 0 01.293-.707c.22-.22.614-.483 1.21-.721C2.407.21 3.564 0 5 0zm0 2c-1.189 0-2.094.165-2.754.428A4.094 4.094 0 002 2.536v9.86C2.82 12.143 3.814 12 5 12c1.417 0 2.383.276 4.371 1.072 1.762.704 2.546.928 3.629.928 1.189 0 2.094-.165 2.754-.428.095-.039.177-.075.246-.108v-9.86c-.82.253-1.814.396-3 .396-1.417 0-2.383-.276-4.371-1.072C6.867 2.224 6.083 2 5 2z",
    id: "alert_svg__a"
  })), (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M0 0h48v48H0z"
  }), (0, _core.jsx)("g", {
    transform: "translate(15 13)"
  }, (0, _core.jsx)("mask", {
    id: "alert_svg__b",
    fill: "#fff"
  }, (0, _core.jsx)("use", {
    xlinkHref: "#alert_svg__a"
  })), (0, _core.jsx)("use", {
    fill: "#889",
    fillRule: "nonzero",
    xlinkHref: "#alert_svg__a"
  }), (0, _core.jsx)("g", {
    mask: "url(#alert_svg__b)",
    fill: color
  }, (0, _core.jsx)("path", {
    d: "M-15-13h48v48h-48z"
  }))))));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = propTypes : void 0;
Icon.defaultProps = defaultProps;
var IconFlag = (0, _stylitas.styled)(Icon)(_templateObject(), _icon.iconBase);
exports.IconFlag = IconFlag;
IconFlag.displayName = 'IconFlag';